export default {
  BLACK: 'var(--dark-blue-grey)',
  AQUAMARINE: 'var(--aquamarine)',
  SKY: 'var(--sky)',
  DANGER: 'var(--danger)',
  WARNING: 'var(--warning)',
  GREY: 'var(--medium-dark)',
};
